export const loadOptiWebComponents = () => {
  return new Promise<void>((resolve, reject) => {
    const alreadyLoaded = document.querySelector(
      'script[src*="optimizely.com/components/web-components.js"]'
    );

    if (alreadyLoaded) {
      resolve();
      return;
    }

    const src = process.env.OPTI_WEB_COMPONENTS_SRC;

    if (!src) {
      reject(new Error('OPTI_WEB_COMPONENTS_SRC is not defined'));
      return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Optimizely Web Components'));
    document.head.appendChild(script);
  });
};
